export default "assets/images/logo-b7a05f85.png";